<template>
  <FpWarningModal
      v-if="helpOpen"
      :open="helpOpen"
      :new-title="'Warning'"
      :description="'Your session has expired. Please input your zip code to continue.'"
      @update:open="(v) => (helpOpen = v)"
  />
</template>
<script setup lang="ts">
const helpOpen = ref(false);
const sessionStore = useSessionStore();
const applicationStore = useApplicationStore();
onMounted(() => {
  setTimeout(() => {
    if (sessionStore.notAuthRedirect && applicationStore.linkRedirect === '') {
      helpOpen.value = true;
      sessionStore.setNotAuthRedirect(false);
    }
  }, 1000)
});
</script>
